// Typelizer digest 01c93543de8b96ec78c7b99b889ce03c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /operation/members */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/operation/members', {}, options),
    method: 'post',
  }),

  /** PATCH /operation/members/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/operation/members/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /operation/members/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/operation/members/:id', params, options),
    method: 'delete',
  }),
}
